module.exports = __webpack_public_path__ + "static/media/casaNoturna.83943372.jpg";